import { Injectable } from "@angular/core";
import { Observable, Subject } from 'rxjs';
import { map } from "rxjs/operators";
import { Http } from "@angular/http";

@Injectable({
    providedIn: 'root'
})

export class getActividad {
    public url;
    constructor(private _http: Http) {
      /*   console.log('Documentos'); */
    }

    getJson(): Observable<any> { return this._http.get("assets/json/actividadINFUS.json") }
    
    getActiv() {
        return this._http.get("assets/json/actividadINFUS.json")
            .pipe(map(res => res.json()));
    }

}